import { useTranslations } from 'next-intl';
import styles from './Services.module.css';

export const InfoServices = ({ occupancy }) => {
  const t = useTranslations();
  return (
    <ul className={styles.list}>
      {!!occupancy?.numGuests && (
        <li>
          {`${occupancy.numGuests} ${
            occupancy.numGuests === 1 ? t('guest') : t('guests')
          }`}
        </li>
      )}
      {!!occupancy?.numBedrooms && (
        <li>
          {`${occupancy.numBedrooms} ${
            occupancy.numBedrooms === 1 ? t('bedroom') : t('bedrooms')
          }`}
        </li>
      )}
      {!!occupancy?.numBeds && (
        <li>
          {`${occupancy.numBeds} ${
            occupancy.numBeds === 1 ? t('bed') : t('beds')
          }`}
        </li>
      )}
      {occupancy?.petsAllowed ? (
        <li>{t('pets-allowed')}</li>
      ) : null}
    </ul>
  );
};
